import { computePosition, offset, flip, shift, arrow, autoUpdate } from '@floating-ui/dom'
import { htmlToElement } from './htmlUtils'

const storage = new WeakMap()

const BASE_CLASSES = {
  tooltip: 'tooltip',
  popover: 'popover'
}

export default function initializeTooltip(button) {
  if (storage.has(button)) {
    return
  }

  const baseClass = BASE_CLASSES[button.dataset.toggle]
  const tooltip = htmlToElement(`
    <div class="${baseClass}" role="tooltip" style="position: absolute; top: 0; left: 0;">
      <div class="tooltip__arrow"></div>
      ${button.title}
    </div>
  `)

  button.append(tooltip)
  button.title = ''

  const arrowElement = tooltip.querySelector('.tooltip__arrow')
  let cleanup = null

  function updatePosition() {
    computePosition(button, tooltip, {
      placement: button.dataset.popperPlacement || 'bottom',
      middleware: [
        offset(8),
        flip(),
        shift({ padding: 5 }),
        arrow({ element: arrowElement })
      ]
    }).then(({ x, y, placement, middlewareData }) => {
      Object.assign(tooltip.style, {
        left: `${x}px`,
        top: `${y}px`
      })

      if (middlewareData.arrow) {
        const { x: arrowX, y: arrowY } = middlewareData.arrow
        Object.assign(arrowElement.style, {
          left: arrowX != null ? `${arrowX}px` : '',
          top: arrowY != null ? `${arrowY}px` : ''
        })
      }

      tooltip.setAttribute('data-placement', placement)
    })
  }

  storage.set(button, { tooltip, cleanup: null })

  function show() {
    tooltip.setAttribute('data-show', '')

    if (cleanup) {
      cleanup()
    }

    cleanup = autoUpdate(button, tooltip, updatePosition)
    storage.set(button, { tooltip, cleanup })
  }

  function hide() {
    tooltip.removeAttribute('data-show')

    if (cleanup) {
      cleanup()
      cleanup = null
      storage.set(button, { tooltip, cleanup: null })
    }
  }

  const showEvents = ['mouseenter', 'focus']
  const hideEvents = ['mouseleave', 'blur']

  showEvents.forEach(event => {
    button.addEventListener(event, show)
  })

  hideEvents.forEach(event => {
    button.addEventListener(event, hide)
  })
}
